import { useCallback, useRef } from 'react';
import { useAppDispatch } from '@/store';
import { updateFeedStats } from '@/store';

// Global debounce map to track calls across all hook instances
const debounceMap = new Map<string, number>();

export const useFeedHover = (feedId: string, debounceDelay: number = 3000) => {
  const dispatch = useAppDispatch();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = useCallback(() => {
    const now = Date.now();
    const lastCall = debounceMap.get(feedId);

    // If this feedId was called recently, skip the call
    if (lastCall && now - lastCall < debounceDelay) {
      return;
    }

    // Clear any existing timeout for this hook instance
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set timeout to make the API calls
    timeoutRef.current = setTimeout(() => {
      dispatch(updateFeedStats(feedId));
      // dispatch(getFeedLikes(feedId));
      debounceMap.set(feedId, Date.now());
    }, 500); // Small delay to batch multiple rapid hovers

  }, [dispatch, feedId, debounceDelay]);

  return { handleMouseEnter };
};